export default __webpack_public_path__ + "static/media/login-car-pic1.e0be1ec3.png";